import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { map } from 'rxjs';
import { BiddingModels } from '../../shared/models/bidding.model';
import { BiddingStoreKey, BiddingStoreService } from '../../store/bidding.store';
import { BidSummaryComponent } from '../bid-summary/bid-summary.component';

@Component({
  selector: 'app-bid-result',
  templateUrl: './bid-result.component.html',
  styleUrls: ['./bid-result.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,

  imports: [FontAwesomeModule, BidSummaryComponent, AsyncPipe],
})
export class BidResultComponent {
  private biddingStoreService = inject(BiddingStoreService);

  biddingResult = BiddingModels.BiddingResult;

  property$ = this.biddingStoreService.propertyDetails.state$.pipe(map(state => state.data));
  bidData$ = this.biddingStoreService.getSelector(BiddingStoreKey.bidData);
  result$ = this.biddingStoreService.getSelector(BiddingStoreKey.bidResult);
  message$ = this.biddingStoreService.getSelector(BiddingStoreKey.bidResultMessage);
}
